module.exports = {"532503001":"文澜街道","532503002":"雨过铺街道","532503003":"观澜街道","532503004":"文萃街道","532503005":"新安所街道","532503102":"草坝镇","532503105":"芷村镇","532503106":"鸣鹫镇","532503107":"冷泉镇","532503201":"期路白苗族乡","532503202":"老寨苗族乡","532503203":"水田乡","532503204":"西北勒乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/532503.json
// module id = 2762
// module chunks = 0